export const meta = {
  id: 'partition-equal-subset-sum',
  name: 'Partition Equal Subset Sum',
  category: 'DP',
  complexity: {
    time: 'O(n * sum)',
    space: 'O(sum)'
  },
  description: 'Partition Equal Subset Sum determines if an array can be partitioned into two subsets with equal sum using dynamic programming.'
};
